<template lang="pug">
.branch-que
  .branch-back(:style="`height: ${backHeight}px;`", @click="onClose")
  dl.branch-info(:style="`top: ${backHeight}px;`")
    dt 飞跃蚂蚁森林
    dd 支线任务：请回答问题
  .branch-que-box
    .branch-que-title 影片末尾提到的蚂蚁森林成绩单，以下选项正确的是：
    template(v-if="!submit")
      .branch-que-item(v-for="(item, i) in list" :key="i", @click="onSelect(i)", :class="i === select ? 'branch-que-item-select' : ''") {{item}}
    template(v-else)
      .branch-que-item(v-for="(item, i) in list" :key="i", :class="getRes(i)") {{item}}  
    .branch-que-btn
      span(@click="onSubmit") 确定   
  .branch-tip
    span(v-show="isCorrect") 恭喜你回答正确！贴纸+1！
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Tip',
  props: {
    backHeight: Number,
  },
  data() {
    return {
      list: ['A.参与用户7.5亿', 'B.种树5.37亿棵', 'C.蚂蚁森林项目2015年上线 '],
      select: NaN,
      correct: 0,
      submit: false,
    }
  },
  computed: {
    ...mapState('app', ['sysInfo', 'router', 'user']),
    isCorrect() {
      return this.submit && (this.select === this.correct);
    }
  },
  methods: {
    ...mapActions('app', ['GetFootprintAddTaskBranchFinish', 'GetFootprintTaskListToday']),
    onClose() {
      this.$emit('close')
    },
    onSelect(index) {
      this.select = index;
    },
    onSubmit() {
      if (isNaN(this.select)) {
        return;
      }

      this.submit = true;
      if (this.select === this.correct) {
        this.fetchFootprintAddTaskBranchFinish();
      }
    },
    getRes(index) {
      if (index === this.correct) {
        return 'branch-que-item-correct';
      }
      if (this.select !== this.correct && index === this.select) {
        return 'branch-que-item-wrong';
      }
    },
    fetchFootprintAddTaskBranchFinish() {
      this.GetFootprintAddTaskBranchFinish({
        userId: this.user.id,
        taskBranchId: 7,
      })
        .then(() => {
          // 需要同步支线数据？
          this.GetFootprintTaskListToday({ userId: this.user.id });
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common"
@import "src/styles/footprint"
.branch-que
  +full; z-index: 9999; position: fixed
  background: rgba(0, 0, 0, 0.75); color: #FFFFFF
  +flex-center
.branch-back
  box-sizing: content-box; padding: 0 ; width: pxRes(21)
  position: absolute; top: 0; left: .88rem;
  background: url("~assets/footprint/icon-video-close.png") center no-repeat
  background-size: pxRes(21)
dl.branch-info
  position: absolute; left: pxRes(30); top: pxRes(30); margin: 0
  dt
    +text(32, 42)
  dd
    +text(16, 22); margin: 0
.branch-que-box
  padding: pxRes(150) pxRes(30) 0
  +text(16, 22); margin: 0; color: #FFFFFF
  .branch-que-title
    padding-bottom: pxRes(14)
  .branch-que-item
    margin-top: pxRes(16); background: #FFFFFF; box-shadow: pxRes(2.5) pxRes(2.5) pxRes(7) rgba(22, 119, 255, 0.1);
    border-radius: pxRes(24);
    color: #3C3C3C; padding: pxRes(5) pxRes(30);
    +text(14, 30)
  .branch-que-item-select
    background: linear-gradient(314.25deg, #0066FF 2.3%, #1677FF 25.27%, #04A6FF 99.78%);
    color: #FFFFFF; position: relative
  .branch-que-item-correct
    background: linear-gradient(314.25deg, #0066FF 2.3%, #1677FF 25.27%, #04A6FF 99.78%);
    color: #FFFFFF; position: relative
    &:after
      content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%;
      background: url("~assets/footprint/icon-correct.png") pxRes(305) center no-repeat;
      background-size: pxRes(26)
  .branch-que-item-wrong
    background: linear-gradient(91.02deg, #F8D7D7 8.99%, #FFAEAE 76.88%); position: relative
    &:after
      content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%;
      background: url("~assets/footprint/icon-wrong.png") pxRes(308) center no-repeat;
      background-size: pxRes(21)
  .branch-que-btn
    padding: pxRes(50) 0 0; text-align: center
    span
      +inline-block; border: 1px solid #1677FF; border-radius: pxRes(18);
      +text(17, 23); padding: pxRes(5) pxRes(30); color: #1677FF;
.branch-tip
  padding: pxRes(66) 0 0; text-align: center; 
  +text(16, 22); margin: 0; color: #FFFFFF; height: pxRes(88)
</style>
